import { UserModel } from '@steelbuy/ts-shared';

import { createCollectionDataContext } from '../../util/provider/CollectionDataProvider';

export const UserCollectionData = createCollectionDataContext<UserModel>();
